import { Grid, Typography } from "@mui/material";
import React from "react";

import NavBar from "../components/Navbar";

export const NotFound = () => {
  return (
    <>
      <NavBar />
      <Grid
        container
        alignContent="center"
        alignItems="center"
        direction="column"
        justify="center"
        style={{
          minHeight: "calc(100% - 64px)",
          paddingLeft: "10vw",
          paddingTop: 88,
          paddingRight: "10vw",
          maxWidth: "100vw",
        }}
      >
        <Grid item style={{ textAlign: "center" }} xs={12}>
          <img
            alt="logo-404"
            src={`${process.env.PUBLIC_URL}/Reports404.png`}
            style={{ marginTop: 26, marginLeft: 8 }}
          />
          <Typography color="textPrimary" style={{ width: "100%" }} variant={"h2"}>
            Document Not Found
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
